<div class="res-popup-title">
  <h1 [ngClass]="{'with-border': subtitle}">{{ title }}</h1>
  <span>{{ subtitle }}</span>
</div>